import React from 'react';
import { ADMIN, MARKETING, SUPER_ADMIN } from '../../../services/admin';
import style from '../../../styles/styles';
import AdminList from '../AdminList/AdminList';
import withTranslation from '../../../hoc/withTranslation';
import PropTypes from 'prop-types';

class AdminBoard extends React.Component {

    static propTypes = {
        admins: PropTypes.object.isRequired,
        handleDeleteAdmin: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
        loading: PropTypes.bool,
    };

    renderAdmins() {
        return this.renderAdminsList(
            this.props.admins.filter(admin => admin.role === ADMIN),
            this.props.t('generic.admins'),
        );
    }

    renderSuperAdmins() {
        let superAdmins = this.props.admins.filter(admin => admin.role === SUPER_ADMIN);
        return this.renderAdminsList(
            superAdmins,
            this.props.t('generic.super_admin', { count: superAdmins.length }),
        );
    }

    renderMarketingAdmins() {
        return this.renderAdminsList(
            this.props.admins.filter(admin => admin.role === MARKETING),
            this.props.t('role.marketing'),
        );
    }

    renderAdminsList = (admins, title) => {
        if (admins && admins.length > 0) {
            return (
                <div style={style.col}>
                    <AdminList
                        admins={admins}
                        loading={this.props.loading}
                        title={title}
                        user={this.props.user}
                        handleRemoveAdmin={this.props.handleDeleteAdmin}
                    />
                </div>
            );
        }
    };
    render() {
        return (
            <div>
                {this.renderSuperAdmins()}
                {this.renderAdmins()}
                {this.renderMarketingAdmins()}
            </div>
        );
    };
}

export default withTranslation(AdminBoard);



// WEBPACK FOOTER //
// src/components/admin/AdminBoard/AdminBoard.js